import {
  NewSettings,
  USER_SETTINGS_CREATE_FAILURE,
  USER_SETTINGS_CREATE_SUCCESS,
  USER_SETTINGS_ON_CHANGE_DROPDOWNS,
  USER_SETTINGS_SUCCESS,
  USER_SETTINGS_TOGGLE,
  USER_SETTINGS_UPDATE_FAILURE,
  USER_SETTINGS_UPDATE_SUCCESS,
  UserSettingsAction,
  UserSettingsState
} from './types';

const initialState: UserSettingsState = {
  isActive: false,
  hasChanged: false,
  actualSettings: undefined,
  newSettings: undefined
};

export default function (state = initialState, action: UserSettingsAction) {
  switch (action.type) {
    case USER_SETTINGS_TOGGLE:
      const newSettingsToggle = <NewSettings>{}
      if (state.newSettings && state.actualSettings) {
        newSettingsToggle.language = state.actualSettings.language
        newSettingsToggle.opco = state.actualSettings.opco
      }

      return {
        ...state,
        newSettings: { ...state.newSettings, ...newSettingsToggle },
        isActive: !state.isActive,
        hasChanged: false
      }

    case USER_SETTINGS_ON_CHANGE_DROPDOWNS:
      const newSettingsOnChangeDropdown = <NewSettings>{}
      if (action.payload.dropdownId === 'opco' && state.newSettings) {
        newSettingsOnChangeDropdown.opco = action.payload.value;
      } else {
        if (state.newSettings) {
          newSettingsOnChangeDropdown.language = action.payload.value;
        }
      }

      const hasChanged =
        newSettingsOnChangeDropdown?.opco !== state.actualSettings?.opco ||
        newSettingsOnChangeDropdown?.language !== state.actualSettings?.language;
      return {
        ...state,
        newSettings: { ...state.newSettings, ...newSettingsOnChangeDropdown },
        hasChanged: hasChanged
      };

    case USER_SETTINGS_SUCCESS:
      const stateClone = { ...state }
      stateClone.actualSettings = action.payload;
      stateClone.newSettings = {
        opco: action.payload.opco,
        language: action.payload.language
      };
      return { ...state, ...stateClone };

    case USER_SETTINGS_UPDATE_SUCCESS:
      return { ...state, isActive: false };

    case USER_SETTINGS_CREATE_SUCCESS:
    case USER_SETTINGS_UPDATE_FAILURE:
    case USER_SETTINGS_CREATE_FAILURE:
    default: {
      return { ...state };
    }
  }
}
